module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M31 0H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm-2 10H3a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zm-7 7a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/box-1.js
// module id = 1023
// module chunks = 14